import AuthService from '../../utilities/services/auth.service'

import { SummaryByPaymentMethodWrapper } from '../../components/SummaryByPaymentMethodWrapper'

export default function SummaryByPaymentMethodPage() {
  const organization = AuthService.getOrg()[0]

  return <SummaryByPaymentMethodWrapper organization={organization} />
}
